import {
  customGetProject,
  customListProjects,
  customGetProjectBoundary,
} from "../../../graphQL/queries";

import {
  customAddProject,
  customDeleteProject,
  customUpdateProject,
  customUpdateProjectBoundary,
  customAddBoundaryPoint,
  customDeleteBoundaryPoint,
  customUpdateBoundaryPoint,
} from "../../../graphQL/mutations";

import {
  createCRUDHandler,
  handleGraphQLResponse,
  client,
} from "./sharedUtils";

interface ProjectInput {
  [key: string]: any;
}

export const projectsClient = {
  /**
   * Project Operations
   */

  /** Get all projects */
  getProjects: createCRUDHandler("customListProjects", customListProjects),

  /** Get a specific project by ID */
  getProject: createCRUDHandler(
    "customGetProject",
    customGetProject,
    (projectId: string) => ({ projectId })
  ),

  /** Create a new project */
  createProject: createCRUDHandler(
    "customAddProject",
    customAddProject,
    (input: ProjectInput) => ({ input: JSON.stringify(input) })
  ),

  /** Update an existing project */
  updateProject: async (projectId: string, input: ProjectInput) => {
    try {

      const response = await client.graphql({
        query: customUpdateProject,
        variables: { projectId: projectId, input: JSON.stringify(input) },
        authMode: "userPool",
      });

      const responseData = (response as any).data?.customUpdateProject;
      if (!responseData) {
        throw new Error("No data returned for operation: customUpdateProject");
      }

      return handleGraphQLResponse(responseData, "customUpdateProject");
    } catch (error) {
      console.error("Error in customUpdateProject:", error);
      throw error;
    }
  },

  /** Delete an project by ID */
  deleteProject: createCRUDHandler(
    "customDeleteProject",
    customDeleteProject,
    (projectId: string) => ({ projectId })
  ),

  /* 
		Project Boundary operations
	*/

  getProjectBoundary: createCRUDHandler(
    "customGetProjectBoundary",
    customGetProjectBoundary
  ),

  updateProjectBoundary: async (projectId: string, input: ProjectInput) => {
    try {

      const response = await client.graphql({
        query: customUpdateProjectBoundary,
        variables: { projectId: projectId, input: JSON.stringify(input) },
        authMode: "userPool",
      });

      const responseData = (response as any).data?.customUpdateProjectBoundary;
      if (!responseData) {
        throw new Error(
          "No data returned for operation: customUpdateProjectBoundary"
        );
      }

      return handleGraphQLResponse(responseData, "customUpdateProjectBoundary");
    } catch (error) {
      console.error("Error in customUpdateProjectBoundary:", error);
      throw error;
    }
  },

  addBoundaryPoint: async (projectId: string, input: ProjectInput) => {
    try {

      const response = await client.graphql({
        query: customAddBoundaryPoint,
        variables: { projectId: projectId, input: JSON.stringify(input) },
        authMode: "userPool",
      });

      const responseData = (response as any).data?.customAddBoundaryPoint;
      if (!responseData) {
        throw new Error(
          "No data returned for operation: customAddBoundaryPoint"
        );
      }

      return handleGraphQLResponse(responseData, "customAddBoundaryPoint");
    } catch (error) {
      console.error("Error in customAddBoundaryPoint:", error);
      throw error;
    }
  },
  deleteBoundaryPoint: async (projectId: string, point_id: string) => {
    try {

      const response = await client.graphql({
        query: customDeleteBoundaryPoint,
        variables: { projectId: projectId, point_id: JSON.stringify(point_id) },
        authMode: "userPool",
      });

      const responseData = (response as any).data?.customDeleteBoundaryPoint;
      if (!responseData) {
        throw new Error(
          "No data returned for operation: customDeleteBoundaryPoint"
        );
      }

      return handleGraphQLResponse(responseData, "customDeleteBoundaryPoint");
    } catch (error) {
      console.error("Error in customDeleteBoundaryPoint:", error);
      throw error;
    }
  },
  updateBoundaryPoint: async (
    projectId: string,
    point_id: string,
    input: ProjectInput
  ) => {
    try {

      const response = await client.graphql({
        query: customUpdateBoundaryPoint,
        variables: {
          projectId: projectId,
          point_id: JSON.stringify(point_id),
          input: JSON.stringify(input),
        },
        authMode: "userPool",
      });

      const responseData = (response as any).data?.customUpdateBoundaryPoint;
      if (!responseData) {
        throw new Error(
          "No data returned for operation: customUpdateBoundaryPoint"
        );
      }

      return handleGraphQLResponse(responseData, "customUpdateBoundaryPoint");
    } catch (error) {
      console.error("Error in customUpdateBoundaryPoint:", error);
      throw error;
    }
  },
};
